module.exports = __webpack_public_path__ + "img/icon-check.ce06fbe1.svg";